module.exports = __webpack_public_path__ + "files/98f6d5c05135a48f04d559a10ee4da81.svg";